import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import "./AccordionComponent.css";
import Service1 from "assets/img/service1_ibukot.png";
import Service2 from "assets/img/service2_sghpdt.png";
import Service3 from "assets/img/service3_whtzze.png";
import Service4 from "assets/img/service4_putdum.png";
import Service5 from "assets/img/service5_dncjzh.png";
import Service6 from "assets/img/service6_erdye5.png";

const AccordionComponent = () => {
  useEffect(() => {
    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger);

    var items = document.querySelectorAll(".accordion-item");

    const ac = document.querySelector(".accordion-container");

    // Create ScrollTrigger for the entire accordion container
    // ScrollTrigger.create({
    //   trigger: ac,
    //   start: "top top",
    //   end: "bottom bottom",
    //   pin: true,
    //   pinSpacing: true,
    //   markers: true,
    // });

    items.forEach((item, index) => {
      const isLastBox = index === item.length - 1;

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "center center",
          end: "bottom top",
          scrub: 5,
          ease: "linear",
          height: 0,
          paddingBottom: 0,
          opacity: 0,
          stagger: 0.5,
          delay: 0.5,
          duration: 0.8,
          // markers: true,
          pinSpacing: true,
          pin: true,
        },
      });
      tl.to(item, {
        opacity: 0.7,
        scale: 0.85,
        backgroundColor: "#f0f0f0",
        duration: 1,
        ease: "power1.inOut",
        // height: 0,
      });

      // Cleanup function
      return () => {
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      };
    });

    // const tl = gsap.timeline({
    //   scrollTrigger: {
    //     // trigger: ".accordion-container",
    //     pinSpacing: true,
    //     pin: true,
    //     start: "top top",
    //     end: "bottom top",
    //     scrub: 5,
    //     ease: "linear",
    //   },
    // });

    // tl.to(".accordion-item:not(:last-child) .accordion-body", {
    //   height: 0,
    //   paddingBottom: 0,
    //   opacity: 0,
    //   stagger: 0.5,
    //   delay: 0.5,
    //   duration: 0.8,
    // });
    // gsap.to(".accordion-item:last-child", {
    //   scrollTrigger: {
    //     trigger: ".accordion-item:last-child",
    //     start: "top top",
    //     end: "bottom top",
    //     pin: true,
    //     pinSpacing: true,
    //   },
    //   duration: 1,
    // });

    // tl.to(
    //   ".accordion-item:not(:last-child)",
    //   {
    //     marginBottom: -55,
    //     stagger: 0.5,
    //   },
    //   "<"
    // );
  }, []);

  return (
    <div id="container-fluid">
      <div id="main-content">
        <div className="accordion-container">
          <div className="accordion-item">
            <div className="accordion-header"></div>
            <div className="accordion-body">
              <div className="row">
                <div className="col-sm-6">
                  <h2>Custom Software Development</h2>
                  <p>
                    We build bespoke software solutions tailored to meet unique
                    business requirements, leveraging the latest technologies
                    and ensuring scalability and efficiency.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img src={Service1} />
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <div className="accordion-header"></div>
            <div className="accordion-body">
              <div className="row">
                <div className="col-sm-6">
                  <h2>User Experience (UX) Design</h2>
                  <p>
                    Our UX design services focus on creating intuitive, engaging
                    interfaces that enhance user interaction and satisfaction,
                    leading to higher retention and better user experiences.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img src={Service2} />
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <div className="accordion-header"></div>
            <div className="accordion-body">
              <div className="row">
                <div className="col-sm-6">
                  <h2>Mobile App Development</h2>
                  <p>
                    We develop high-performance mobile applications for iOS and
                    Android, designed to provide seamless user experiences and
                    support business growth through mobile engagement.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img src={Service3} />
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <div className="accordion-header"></div>
            <div className="accordion-body">
              <div className="row">
                <div className="col-sm-6">
                  <h2>AI Solutions</h2>
                  <p>
                    Our AI solutions provide cutting-edge artificial
                    intelligence capabilities, including data analysis, natural
                    language processing, and machine learning, enhancing
                    decision-making, automating processes, and delivering
                    personalized user experiences.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img src={Service4} />
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <div className="accordion-header"></div>
            <div className="accordion-body">
              <div className="row">
                <div className="col-sm-6">
                  <h2>Data Analytics & BI</h2>
                  <p>
                    We provide data analytics and business intelligence
                    solutions, transforming raw data into actionable insights,
                    enabling data-driven decision-making and strategic growth.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img src={Service5} />
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <div className="accordion-header"></div>
            <div className="accordion-body">
              <div className="row">
                <div className="col-sm-6">
                  <h2>IT Consulting</h2>
                  <p>
                    Our IT consulting services guide businesses through
                    technology strategy, infrastructure planning, and digital
                    transformation, ensuring alignment with business goals and
                    industry standards.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img src={Service6} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionComponent;
